var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 950 950",
    width: 512,
    height: 512,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vecteezy_initial-letter-f-logo-blue-geometric-shape-origami-style_8383312-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m207.78 539.26c38.97-93.98 93.79-134.42 194.84-134.42q78.32 0 156.65 0c111.39 0 188.85-64.81 196.25-178.68-137.65 0-275.44-6-412.97 0-172.51 7.51-148.13 238.55-134.77 313.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-407.46,-0.04,.022,-222.103,677.678,538.293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3290fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11d0fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m345.6 559.46v43.77c0 84.67-49.26 143.54-135.8 149.17l-0.43-59.87 30.98-133.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,142.78,-100.817,0,414.109,592.187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3290fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11d0fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m209.72 729.02c39.95-110.98 108.96-160.42 201.68-160.42 35.45 0 50.04 0 85.5 0 84.66 0 143.54-49.26 149.16-135.81-104.63 0-188.5-4.54-293.02 0-131.1 5.7-149.3 169.43-143.32 296.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,120.229,-176.813,0,527.159,459.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0be3fc"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: url(#g2) } \n\t\t.s2 { fill: url(#g3) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m170 538.3h585.5v-319.1h-585.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m209.4 751.4h136.2v-192.9h-136.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m203.7 728h442.4v-300.8h-442.4z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.0e867bf774e6e4e91c349897215da8a4.svg";